import { log } from 'log';
import { useCallback } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { languageService } from 'js/services/language.service';
import * as constants from '../../../constants';

export const useRequestSolusPacket = ({
    sdk,
    license,
    transactionID,
    userId,
    identifierType,
    reasonRef
}) => {
    const lang = useUserSelector(prop('lang'));
    const twoLetterLang = languageService.getTwoLetterLanguage(lang);

    return useCallback(() => {
        log('gcReq', { transactionID, license });

        switch (reasonRef.current) {
            case constants.GEOLOCATION_REASON.FOREGROUND_CHECK:
                sdk.setReasonCode(sdk.REASON_CODE.POST_INTERVAL_FOREGROUND);
                break;
            case constants.GEOLOCATION_REASON.IP_CHANGE_CHECK:
                sdk.setReasonCode(sdk.REASON_CODE.IPCHANGE);
                break;
            case constants.GEOLOCATION_REASON.INITIAL_CHECK:
                sdk.setReasonCode(sdk.REASON_CODE.LOGIN);
                break;
            case constants.GEOLOCATION_REASON.INTERVAL_CHECK:
                sdk.setReasonCode(sdk.REASON_CODE.INTERVAL);
                break;
            case constants.GEOLOCATION_REASON.RECONNECT_CHECK:
                sdk.setReasonCode(sdk.REASON_CODE.POST_INTERVAL_FOREGROUND);
                break;
            case constants.GEOLOCATION_REASON.ACL_RULE_FAILURE_CHECK:
                sdk.setReasonCode(sdk.REASON_CODE.USER_DRIVEN_RETRY);
                break;
            default:
                // no op
                break;
        }

        sdk.setReason(reasonRef.current);

        sdk.setLicense(license);
        sdk.setUserId(userId);
        sdk.setUserSessionId(transactionID);
        sdk.customFields.set('transactionId', transactionID);
        sdk.customFields.set('identifier_type', identifierType);
        sdk.customFields.set('language', twoLetterLang);

        sdk.request({
            acceptNoCoordinates: false
        });
    }, [
        sdk,
        license,
        transactionID,
        userId,
        reasonRef,
        identifierType,
        twoLetterLang
    ]);
};
